import { Component, OnDestroy } from '@angular/core';
import { NavController, MenuController, ViewController, AlertController, LoadingController, ToastController, ModalController, Platform, ActionSheetController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { Subject } from 'rxjs';

import { ProductsHorizontalPage } from '../products/productsHorizontal/productsHorizontal';
import { ProductsNoImageListPage } from '../products/productsNoImageList/productsNoImageList';
import { ProductsVerticalPage } from '../products/productsVertical/productsVertical';
import { ProductsWithImageList } from '../products/productsWithImageList/productsWithImageList';
import { SlotsListPage } from '../products/slotsList/slotsList';
import { productDetailPage } from '../productDetail/productDetail';

import { provider } from '../../providers/provider';
//import { CombPage } from '../comb/comb';
import { CartPage } from '../cart/cart';
import { CustomerPage } from '../account/customer/customer';
import { Search } from '../search/search';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { HomePage } from '../home/home';
import { AboutPage } from '../about/about';

@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html'
})
export class MenuPage implements OnDestroy {
  url: any;
  rootPage = HomePage;
  menu: any;
  ragioneSociale: any;
  appType: any;
  items = [];
  tot = 0;
  contCart = 0;
  number: any;
  creditoResiduo = 0;
  prepaidcard: any;
  customercode: any;
  customerInfo: any;
  hideCustomer = false;
  isTakeAway = false;
  width: any;
  height: any;
  tavolo;
  private _onDestroy = new Subject();
  temporaryCustomer = null;
  whenTakeAway = undefined;
  howTakeAway = undefined;
  highResImages: boolean;
  heightBlock: any;
  widthBlock: any;

  constructor(public navCtrl: NavController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public provider: provider,
    public viewCtrl: ViewController,
    public translateService: TranslateService,
    public storage: Storage,
    public platform: Platform,
    public customizer: CustomizerProvider,
    public actionSheetCtrl: ActionSheetController,
    public menuCtrl: MenuController,
    public navParams: NavParams,) {
    
    // blocco tasto indietro
    platform.registerBackButtonAction(() => {
      this.goHome();
    });

    this.url = provider.getUrl();

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();

      this.heightBlock = Math.floor((((this.height-44)/100)*30)) + 'px';
      this.widthBlock = this.width + 'px';
    });

    this.getCustomer();
    this.getTotal();

    if(navParams.get('when')) {
      this.whenTakeAway = navParams.get('when').slot;
      this.howTakeAway = navParams.get('how');
    }

  }

  getCustomer() {
    if(this.provider.getPrepaidCard()) {
      this.storage.get('customer').then((customer) => {
        this.customerInfo = JSON.parse(customer);
        if(this.customerInfo) {
          this.provider.cardsBackup(this.customerInfo.telephone, this.customerInfo._id).takeUntil(this._onDestroy).subscribe(data => {
            let tessere = JSON.parse((<any>data)._body);
            tessere.forEach(element => {
              this.storage.set(element.customercode, element.hash);
            });
          }, err => {
            //console.log(err)
          });
        }
      });
    }
  }

  openMenu() {
    this.menuCtrl.open().then(() => {
      this.storage.get('customer').then((customer) => {
        this.customerInfo = JSON.parse(customer);
      });
    });    
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  ionViewDidEnter() {
    this.getCustomer();
    this.getTotal();
  }

  getUrl(img) {
    if(this.highResImages)
      return this.url + img;
    else
      return this.url + img + '?w=' + this.width + '&h=' + Math.floor((this.height/100)*30);
  }

  cart() {
    this.navCtrl.push(CartPage);
  }

  card() {
    let modal = this.modalCtrl.create(CustomerPage);
    modal.present();
  }

  showAlert(message) {
    this.provider.setSelectedLocale(false);
    this.translateService.get("ATTENZIONE").takeUntil(this._onDestroy).subscribe(msg => {
      let alert = this.alertCtrl.create({
        title: msg.ATTENZIONE,
        message: message,
        buttons: [
          {
            text: 'OK',
            role: 'cancel',
            handler: () => {
              location.reload();
            }
          }
        ]
      });
      alert.present();
    });
  }

  infoLocale() {
    this.navCtrl.push(AboutPage);
  }

  translate() {
    let lang = ['it', 'en', 'fr', 'es', 'de','nl'];

    this.translateService.get('LANGUAGE').takeUntil(this._onDestroy).subscribe(obj => {
      let buttons = obj.languages.map((language, index) => ({
        text: language, handler: () => { this.storage.set('language', lang[index]); this.translateService.use(lang[index]); }
      }))
      let actionSheet = this.actionSheetCtrl.create({
        title: obj.label,
        buttons
      });
      actionSheet.present();
    });
  };

  versionAlert() {
    this.provider.setSelectedLocale(false);

    let alert = this.alertCtrl.create({
      title: 'Modalità "Sfoglia Menu"',
      message: 'Ci dispiace ma questa versione di Android non è compatibile con il servizio di ordine.',
      buttons: [
        {
          text: 'OK',
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  showItem(item, righe) {
    if (item.contentType == "ProdVarIngr") {
      this.navCtrl.push(productDetailPage, { product: item });
    }
    else if (item.contentType == "Tag") {
      //pubblicità
      let isAdv = righe.filter((element) => element.parent == item._id);
      if (isAdv.length == 0) return;

      if (this.customizer.isWebAppMode())
        // in webapp-mode show products in normal mode
        this.navCtrl.push(ProductsWithImageList, { group: item });
      else {
        // in app mode show products based on viewType variable
        if(item.viewType == 'vertical')
          this.navCtrl.push(ProductsVerticalPage, { group: item });
        else if(item.viewType == 'horizontal')
          this.navCtrl.push(ProductsHorizontalPage, { group: item });
        else if(item.viewType == 'image-list') 
          this.navCtrl.push(ProductsWithImageList, { group: item });
        else
          this.navCtrl.push(ProductsNoImageListPage, { group: item });
      }
    }
  }

  showSlots(item) {
    this.navCtrl.push(SlotsListPage, { group: item });
  }

  getTotal() {
    this.tot = this.provider.showTotal();
  }

  ionViewDidLoad() {
    let message: string;

    this.temporaryCustomer = this.provider.getTemporaryCustomer();

    let loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });
    loading.present().then(() => {
      this.provider.getData(this.whenTakeAway, this.howTakeAway).then(data => {
        loading.dismiss().then(() => {
          {
            if (data._body != undefined && typeof data._body !== "object") {
              switch (data._body) {
                case 'E1000':
                  this.translateService.get('E1000').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1001':
                  this.translateService.get('E1001').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1002':
                  this.translateService.get('E1002').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1003':
                  this.translateService.get('E1003').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1004':
                  this.translateService.get('E1004').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1005':
                  this.translateService.get('E1005').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1006':
                  this.translateService.get('E1006').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1007':
                  this.translateService.get('E1007').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1008':
                  this.translateService.get('E1008').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1009':
                  this.translateService.get('E1009').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                case 'E1010':
                  this.translateService.get('E1010').takeUntil(this._onDestroy).subscribe(value => { message = data._body + " - " + value });
                  break;
                default:
                  this.translateService.get('E1000').takeUntil(this._onDestroy).subscribe(value => { message = value });
                  console.log(data);
                  break;
              }
              this.showAlert(message);
            }

            else if (data.tavolo.bloccato && data.settings.richiedeSblocco) {
              this.translateService.get('E1006').takeUntil(this._onDestroy).subscribe(value => { message = value });
              this.showAlert(message);
            }

            else {
              // handle temporary customer if available
              if (this.temporaryCustomer) {
                //using data handed from the order manager redirection
                this.customerInfo = this.temporaryCustomer;
                this.hideCustomer = true;
              }

              // handle data of hotel
              if(data.tavolo.itsHotelRoom) {
                // got informations from hotel room. Use hotel room informations for customer
                this.customerInfo = data.tavolo.hotelRoom;
                this.hideCustomer = true;
              }

              let isSfogliamenu = this.provider.isSfogliamenu();
              // valid menu found. process room data
              if (data.menu.righe != 0) {
                if(isSfogliamenu) {
                  data.settings.payment.when = 'SFOGLIAMENU';
                  this.appType = 'SFOGLIAMENU';
                }
                else 
                  this.appType = data.settings.payment.when;

                this.prepaidcard = data.settings.payment.how.card;
                this.provider.setPrepaidCard(data.settings.payment.how.card);
                this.provider.setCoupon(data.settings.couponModuleIsActive);
                this.customercode = data.settings.customercode;
                this.menu = data.menu.righe;
                this.ragioneSociale = data.settings.ragioneSociale;
                this.storage.set('client_id', data.settings.clientId);
                this.tavolo = data.tavolo;
                this.isTakeAway = data.tavolo.isTakeAway;

                // apply forced menu selection based on custom key
                this.storage.get('modeTakeAwayOrDelivery').then((mode) => {
                  if (mode !== null)
                    data.menu.takeAwayOptions = mode;
                });

                this.storage.get('versione').then((v) => {
                  if (v.android.num < 5) {
                    data.settings.payment.when = 'SFOGLIAMENU';
                    this.appType = 'SFOGLIAMENU';
                    this.versionAlert();
                  }
                }).catch(function (err) {
                  console.log("Nessuna versione di android è stata trovata")
                });

                for (let i = 0; i < data.menu.righe.length; i++) {
                  if (data.menu.righe[i].parent == null) {
                    this.items.push(data.menu.righe[i]);
                  }
                }

                this.menu.sort(function (a, b) {
                  return a.ordering - b.ordering
                });

                if (this.appType == 'SFOGLIAMENU' && data.settings.payment.how.kiosko) {
                  this.storage.set('codSfogliaMenu', this.provider.getToken());
                }

                if (data.settings.richiedeSblocco) {
                  this.alertRichiestaCodice();
                }

              }
              else {
                this.showAlert("il Menu è vuoto!");
              }
            }
          }
        })
      }),
        () => {
          loading.dismiss();
        };
    });

  }

  alertRichiestaCodice() {
    this.translateService.get(['CODICE', 'COD', 'ANNULLA', 'COD_ERRATO']).takeUntil(this._onDestroy).subscribe(msg => {
      const prompt = this.alertCtrl.create({
        title: msg.CODICE,
        enableBackdropDismiss: false,
        inputs: [
          {
            name: "cod",
            placeholder: msg.COD
          },
        ],
        buttons: [
          {
            text: 'OK',
            handler: resp => {
              let loading = this.loadingCtrl.create({
                content: '<ion-spinner name="circles"></ion-spinner>'
              });
              loading.present();
              this.provider.sbloccaTavolo(this.tavolo._id, resp.cod).takeUntil(this._onDestroy).subscribe(data => {
                loading.dismiss();
              },
                err => {
                  loading.dismiss();
                  this.showAlert(msg.COD_ERRATO);
                });
            }
          }
        ]
      });
      prompt.present();
    });
  }

  search() {
    this.navCtrl.push(Search);
  }
  
  goHome() {
    // if cart is not empty, ask user
    const cart = this.provider.getCart();
    if (cart.length > 0) {
      this.translateService.get(['ATTENZIONE', 'CART_IS_NOT_EMPTY', 'PROCEED', 'ANNULLA']).takeUntil(this._onDestroy).subscribe(msg => {
        const prompt = this.alertCtrl.create({
          title: msg.ATTENZIONE,
          message: msg.CART_IS_NOT_EMPTY,
          buttons: [
            { text: msg.ANNULLA },
            {
              text: msg.PROCEED,
              handler: result => {
                this.provider.setSelectedLocale(false);
                this.provider.clearApp();
                location.reload();
                this.navCtrl.push(HomePage);
              }
            }
          ]
        });
        prompt.present();
      });
    } else {
      // go back to home
      this.provider.setSelectedLocale(false);
      this.provider.clearApp();
      location.reload();
      this.navCtrl.push(HomePage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts